import {Injectable} from '@angular/core';
import {map} from "rxjs";
import { MyAccountService } from './my-account.service';

@Injectable({
  providedIn: 'root',
})

export class CustomPageService {

  constructor(private myAccountService: MyAccountService) {}

  getCustomPage(page: any) {
    return this.myAccountService.httpPost('page/custom', page).pipe(map(response => {
      const {value} = (response as any).data;
      return value;
    }));
  }
}
